/**
 * Cashflow Cdn
 *
 * Added: Nov 1, 2022
 *
 * */

// Globals: jQuery, cashflow, WindowUtilities
function Cashflow() {
    this.accountId = window.location && window.location.host ? window.location.host.split('.')[0] : false;
    this.init();
}

Cashflow.prototype = {
    init() {

        (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
            v=['initialize','identify','updateOptions','pageLoad'];for(w=0,x=v.length;w<x;++w)(function(m){
                o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
            y=e.createElement(n);y.type="module";y.async=!0;y.src='https://cdn.services.gainspro.com/components/0.3.1/gains-components/gains-components.esm.js';
            z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);
        })(window,document,'script','cashflow');
    },


};

const caCashflow = new Cashflow();
